const styleElement = document.createElement("dom-module");

styleElement.innerHTML = `<template>
    <style>
        .filter-webinar-status-container {
            background-color: #FFFFFF;
            border-radius: 4px;
            border: solid 1px #D9D9D9;
            margin-bottom: 16px;
            padding: 16px;
        }

        h2 {
            color: #000000;
            font-size: 18px;
            font-weight: 600;
            margin: 0;
            line-height: 24px;
        }

        hr {
            border: none;
            height: 1px;
            color: #ECECEC;
            background-color: #ECECEC;
            margin: 16px 0;
        }

        .item-webinar-status-container {
            padding:  8px 0;
        }

        .item-webinar-status-container label {
            font-size: 16px;
            font-weight: 400;
            color: #424242;
            width: 100%;
            display: block;
            cursor: pointer;
            line-height: 22px;
        }

        .webinar-status-list-container {
            overflow-y: auto;
            max-height: 300px;
            font-size: 14px;
            margin-top: 10px;
        }
    </style>
</template>`
styleElement.register("filter-webinar-type-style");